export const serializeParams = params => {
  if (!params) {
    return ''
  }

  return Object.keys(params)
    .map(key => {
      const value = decodeParam(params[key])
      return `${key}=${encodeURIComponent(value)}`
    })
    .join('&')
}

const decodeParam = value => {
  let prevValue = value
  let decodedValue = decodeURIComponent(value)

  while (prevValue !== decodedValue) {
    prevValue = decodedValue
    decodedValue = decodeURIComponent(decodedValue)
  }

  return decodedValue
}
